interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, total: number): (number | string)[] {
  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || (i >= page - 1 && i <= page + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...');
    }
  }
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-2 flex-wrap">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-800 whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <i className="ri-arrow-left-s-line mr-1"></i>
        上一页
      </button>
      {buildPages(page, totalPages).map((p, idx) =>
        typeof p === 'number' ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`w-10 h-10 rounded-md text-sm font-medium cursor-pointer transition-colors ${
              p === page
                ? 'bg-primary-500 text-background-950 font-bold'
                : 'border border-background-300 text-foreground-800 hover:bg-background-200'
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${idx}`} className="w-8 text-center text-foreground-500">
            …
          </span>
        ),
      )}
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-800 whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      >
        下一页
        <i className="ri-arrow-right-s-line ml-1"></i>
      </button>
    </div>
  );
}